// Tasas IMSS de empleado para CDMX/Edo. Méx.
// Clasificación de guardias (seguridad)
export const imssRates = {
  cesantia_vejez: 0.01125,
  enfermedad_maternidad: 0.004,
  invalidez_vida: 0.00625,
};

// Porcentaje total de contribución del empleado al IMSS (6.25%)
const totalIMSSRate = 0.01125 + 0.004 + 0.00625;

/**
 * Calcular la deducción del IMSS (aportación del empleado)
 * @param {number} sbc - Salario Base de Cotización (base mensual)
 * @param {object} rates - Objeto con las tasas del IMSS
 * @returns {object} Desglose de la deducción del IMSS
 */
export const calculateIMSS = (sbc, rates = imssRates) => {
  const cesantia_vejez = sbc * rates.cesantia_vejez;
  const enfermedad_maternidad = sbc * rates.enfermedad_maternidad;
  const invalidez_vida = sbc * rates.invalidez_vida;

  const employee = cesantia_vejez + enfermedad_maternidad + invalidez_vida;

  return {
    cesantia_vejez,
    enfermedad_maternidad,
    invalidez_vida,
    employee,
  };
};


 // Convertir cualquier periodo a una base mensual
export const toMonthly = (amount, period) => {
  switch (period) {
    case "weekly":
      return amount * 4.333;
    case "biweekly":
      return amount * 2;
    case "monthly":
    default:
      return amount;
  }
};


// Convertir un importe mensual al periodo original
export const fromMonthly = (amount, period) => {
  switch (period) {
    case "weekly":
      return amount / 4.333;
    case "biweekly":
      return amount / 2;
    case "monthly":
    default:
      return amount;
  }
};

/**
 * Calcular IMSS para cualquier periodo
 * @param {number} income - Ingreso para el periodo
 * @param {string} period - "weekly", "biweekly", o "monthly"
 * @returns {object} Desglose de la deducción del IMSS con tasas
 */
export const calculateIMSSForPeriod = (income, period = "weekly") => {
  const monthly = toMonthly(income, period);
  const imssMonthly = calculateIMSS(monthly);
  const imss = fromMonthly(imssMonthly.employee, period);

  return {
    grossMonthly: monthly,
    imssMonthly: imssMonthly.employee,
    imss,
    breakdown: imssMonthly,
    rates: {
      cesantia_vejez: (imssRates.cesantia_vejez * 100).toFixed(2),
      enfermedad_maternidad: (imssRates.enfermedad_maternidad * 100).toFixed(2),
      invalidez_vida: (imssRates.invalidez_vida * 100).toFixed(2),
      total: ((imssRates.cesantia_vejez + imssRates.enfermedad_maternidad + imssRates.invalidez_vida) * 100).toFixed(2),
    },
  };
};